import { motion } from "framer-motion";

/**
 * Scroll-triggered reveal wrapper. Fades + rises children into view once.
 */
export const Reveal = ({
  children,
  delay = 0,
  y = 28,
  className = "",
  as = "div",
  once = true,
  duration = 0.9,
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
